/**
 * Backend API URL Configuration
 * Determines the correct backend URL based on environment
 * This runs at runtime to properly detect production vs localhost
 */

const getBackendUrl = () => {
  // Runtime check based on hostname
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;

    // Production domains - use production backend
    if (hostname === 'boardchat.io' ||
        hostname === 'www.boardchat.io' ||
        hostname.includes('web.app') ||
        hostname.includes('firebaseapp.com')) {
      const productionUrl = 'https://boardchat-api-1087165787703.us-central1.run.app';
      console.log('🌐 Production detected (' + hostname + '), using:', productionUrl);
      return productionUrl;
    }

    // Localhost or local IP - use local backend
    if (hostname === 'localhost' ||
        hostname === '127.0.0.1' ||
        hostname.startsWith('192.168.') ||
        hostname.startsWith('10.')) {
      console.log('💻 Development mode, using localhost:8000');
      return 'http://localhost:8000';
    }
  }

  // Fallback to localhost for any other case
  console.log('⚠️ Unknown environment, defaulting to localhost:8000');
  return 'http://localhost:8000';
};

// Export as getter functions to ensure runtime evaluation
export const getBackendUrlValue = () => getBackendUrl();

const backendUrl = getBackendUrl();
export const BACKEND_URL = backendUrl;

// All backends need /api path
export const API_URL = `${backendUrl}/api`;

// Log the configuration for debugging
if (typeof window !== 'undefined') {
  console.log('🔗 Backend URL:', BACKEND_URL);
  console.log('🔗 API URL:', API_URL);
  console.log('🔗 Hostname:', window.location.hostname);
  console.log('🔗 Full URL:', window.location.href);
}
